<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <!-- 顶部圆形图标 -->
      <div class="logo-container">
        <img :src="shopLogo" alt="商户端" class="logo-img" />
        <h1 class="logo-title" v-if="!isCollapse">{{ shopName }}</h1>
      </div>

      <!-- 左侧导航 -->
      <!-- 左侧导航 -->
      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#bfcbd9"
        active-text-color="#409EFF" router :collapse="isCollapse" unique-opened>
        <!-- 控制台 -->
        <el-menu-item index="/dashboard">
          <el-icon>
            <Monitor />
          </el-icon>
          <span>控制台</span>
        </el-menu-item>

        <!-- 账号管理 -->
        <el-menu-item index="/account">
          <el-icon>
            <User />
          </el-icon>
          <span>账号管理</span>
        </el-menu-item>

        <!-- 文章管理 -->
        <el-sub-menu index="/article">
          <template #title>
            <el-icon>
              <Document />
            </el-icon>
            <span>文章管理</span>
          </template>
          <el-menu-item index="/article/category">
            <el-icon>
              <Folder />
            </el-icon>
            <span>文章分类</span>
          </el-menu-item>
          <el-menu-item index="/article/create">
            <el-icon>
              <EditPen />
            </el-icon>
            <span>文章创作</span>
          </el-menu-item>
          <el-menu-item index="/article/greenbook">
            <el-icon>
              <Notebook />
            </el-icon>
            <span>绿书创作</span>
          </el-menu-item>
          <el-menu-item index="/article/list">
            <el-icon>
              <List />
            </el-icon>
            <span>文章列表</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 爆文改写 -->
        <el-menu-item index="/rewrite">
          <el-icon>
            <MagicStick />
          </el-icon>
          <span>爆文改写</span>
        </el-menu-item>

        <!-- 绿书发布 -->
        <el-sub-menu index="/greenbook">
          <template #title>
            <el-icon>
              <Upload />
            </el-icon>
            <span>绿书发布</span>
          </template>
          <el-menu-item index="/greenbook/draft">
            <el-icon>
              <DocumentCopy />
            </el-icon>
            <span>草稿任务</span>
          </el-menu-item>
          <el-menu-item index="/greenbook/record">
            <el-icon>
              <Clock />
            </el-icon>
            <span>发布记录</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 文章发布 -->
        <el-sub-menu index="/publish">
          <template #title>
            <el-icon>
              <Promotion />
            </el-icon>
            <span>文章发布</span>
          </template>
          <el-menu-item index="/publish/draft">
            <el-icon>
              <DocumentCopy />
            </el-icon>
            <span>草稿任务</span>
          </el-menu-item>
          <el-menu-item index="/publish/record">
            <el-icon>
              <Clock />
            </el-icon>
            <span>发布记录</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 素材管理 -->
        <el-sub-menu index="/material">
          <template #title>
            <el-icon>
              <Picture />
            </el-icon>
            <span>素材管理</span>
          </template>
          <el-menu-item index="/material/title">
            <el-icon>
              <CollectionTag />
            </el-icon>
            <span>下拉词库</span>
          </el-menu-item>
          <el-menu-item index="/material/gallery">
            <el-icon>
              <Picture />
            </el-icon>
            <span>图库管理</span>
          </el-menu-item>
          <el-menu-item index="/material/header-ad">
            <el-icon>
              <VideoPlay />
            </el-icon>
            <span>头部广告</span>
          </el-menu-item>
          <el-menu-item index="/material/footer-ad">
            <el-icon>
              <VideoPause />
            </el-icon>
            <span>尾部广告</span>
          </el-menu-item>
          <el-menu-item index="/material/call">
            <el-icon>
              <Phone />
            </el-icon>
            <span>一键拨号</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 系统配置子菜单 -->
        <el-sub-menu index="/system">
          <template #title>
            <el-icon>
              <Setting />
            </el-icon>
            <span>系统配置</span>
          </template>

          <el-menu-item index="/system/Moban" v-if="moduleStatus.tweet_template === 2">
            <el-icon>
              <Memo />
            </el-icon>
            <span>推文模版</span>
          </el-menu-item>

          <el-menu-item index="/system/model" v-if="moduleStatus.writing_model === 2">
            <el-icon>
              <Cpu />
            </el-icon>
            <span>写作模型</span>
          </el-menu-item>

          <el-menu-item index="/system/medium-api" v-if="moduleStatus.media_model === 2">
            <el-icon>
              <Camera />
            </el-icon>
            <span>媒体模型</span>
          </el-menu-item>

          <el-menu-item index="/system/title-api" v-if="moduleStatus.title_api === 2">
            <el-icon>
              <Connection />
            </el-icon>
            <span>标题接口</span>
          </el-menu-item>

          <el-menu-item index="/system/command">
            <el-icon>
              <MagicStick />
            </el-icon>
            <span>创作指令</span>
          </el-menu-item>

          <el-menu-item index="/system/clever" v-if="moduleStatus.ai_agent === 2">
            <el-icon>
              <eleme />
            </el-icon>
            <span>AI智能体</span>
          </el-menu-item>

          <el-menu-item index="/system/OssConfig" v-if="moduleStatus.storage_config === 2">
            <el-icon>
              <FolderChecked />
            </el-icon>
            <span>存储配置</span>
          </el-menu-item>

          <el-menu-item index="/system/publish">
            <el-icon>
              <SetUp />
            </el-icon>
            <span>基础设置</span>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">

        <div class="nav-center">
          <div class="info-item points">
            <el-icon class="icon">
              <Star />
            </el-icon>
            <span class="label">点数:</span>
            <span class="value">{{ points === -1 ? '无限制' : points.toFixed(1) }}</span>

          </div>
          <div class="info-item auth">
            <el-icon class="icon">
              <Key />
            </el-icon>
            <span class="label">授权数:</span>
            <span class="value">{{ sqNum === -1 ? '无限制' : sqNum }}</span>

          </div>
          <div class="info-item expire">
            <el-icon class="icon">
              <Calendar />
            </el-icon>
            <span class="label">过期时间:</span>
            <span class="value">{{ formattedOutDate }}</span>
          </div>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="30" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon">
                <ArrowDown />
              </el-icon>

            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showCardRechargeDialog">
                  <el-icon>
                    <CreditCard />
                  </el-icon>卡密充值
                </el-dropdown-item>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon>
                    <Edit />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
  <!-- 卡密充值对话框 -->
  <el-dialog v-model="showCardDialog" title="卡密充值" width="400px" :close-on-click-modal="false">
    <el-form :model="cardForm" label-width="80px">
      <el-form-item label="卡密">
        <el-input v-model="cardForm.code" placeholder="请输入充值卡密" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showCardDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitCardRecharge">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false">
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showPasswordDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>


</template>

<script>
import {
  Monitor,
  User,
  Document,
  Folder,
  EditPen,
  Notebook,
  List,
  MagicStick,
  Upload,
  DocumentCopy,
  Clock,
  Promotion,
  Picture,
  CollectionTag,
  VideoPlay,
  VideoPause,
  Phone,
  Setting,
  Cpu,
  Connection,
  eleme,
  CreditCard,
  Camera,
  Memo,
  FolderChecked,
  SetUp
} from '@element-plus/icons-vue'
import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'
import { Star, Key, Calendar } from '@element-plus/icons-vue'
// 在这里添加 ModuleStatus 接口定义



export default {
  name: 'MainLayout',
  components: {
    Monitor,
    CreditCard,
    User,
    Document,
    Folder,
    EditPen,
    Notebook,
    List,
    MagicStick,
    Upload,
    DocumentCopy,
    Clock,
    Promotion,
    Picture,
    CollectionTag,
    VideoPlay,
    VideoPause,
    Phone,
    Setting,
    Cpu,
    Connection,
    eleme,
    SetUp,
    Star,
    Key,
    Camera,
    Memo,
    FolderChecked,
    Calendar
  },

  setup() {
    const router = useRouter()


    // 正确的 ref 定义（去掉多余空格）
    const moduleStatus = ref({
      tweet_template: 2,
      writing_model: 2,
      media_model: 2,
      title_api: 2,
      ai_agent: 2,
      storage_config: 2
    });
    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isLoggedIn = ref(!!Cookies.get('user_token'))
    const shopLogo = ref('@/assets/logo.gif') // 默认logo
    const shopName = ref('商户端') // 默认名称
    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)
    const points = ref(0) // 初始化为0
    const sqNum = ref(0)
    const outDate = ref('')
    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')
    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(account)

    const activeMenu = computed(() => {
      const route = router.currentRoute.value
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })
    const showPasswordDialog = ref(false)
    const form = reactive({
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })
    const showCardDialog = ref(false)
    const cardForm = reactive({
      code: ''
    })

    // 显示卡密充值对话框
    const showCardRechargeDialog = () => {
      cardForm.code = ''
      showCardDialog.value = true
    }

    // 获取模块权限状态
    const fetchModuleStatus = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/module_hidden.php`, {
          store_id: userInfo.id
        });

        if (response.data.data) {
          moduleStatus.value = response.data.data;
        }
      } catch (error) {
        console.error('获取模块权限失败:', error);
        // 使用默认全选状态
        moduleStatus.value = {
          tweet_template: 2,
          writing_model: 2,
          media_model: 2,
          title_api: 2,
          ai_agent: 2,
          storage_config: 2
        };
      }
    };

    // 提交卡密充值
    const submitCardRecharge = async () => {
      if (!cardForm.code) {
        ElMessage.error('请输入卡密')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'recharge_card',
          account: account,
          code: cardForm.code
        })

        if (response.data.success) {
          ElMessage.success('充值成功')
          // 刷新点数信息
          await loadPoints()
          showCardDialog.value = false
        } else {
          ElMessage.error(response.data.message || '充值失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      }
    }

    // 加载点数数据
    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account: account
        })

        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
          sqNum.value = parseInt(response.data.data.sq_num) || 0 // 新增 parseInt 转换

          outDate.value = response.data.data.out_date || ''

        } else {
          ElMessage.error('点数加载失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        ElMessage.error('接口请求失败: ' + error.message)
      }
    }

    // 修改密码方法
    const submitPassword = async () => {
      // 前端验证
      if (!form.oldPwd) {
        ElMessage.error('请输入旧密码')
        return
      }
      if (!form.newPwd) {
        ElMessage.error('请输入新密码')
        return
      }
      if (form.newPwd !== form.confirmPwd) {
        ElMessage.error('两次输入的新密码不一致')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'update_password',
          account: account,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })

        if (response.data.success) {
          ElMessage.success('密码修改成功，请重新登录')
          // 清除登录状态
          Cookies.remove('user_token')
          router.push('/login')
        } else {
          ElMessage.error(response.data.message || '密码修改失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    // 修改密码按钮点击事件
    const handleModifyPassword = () => {
      // 重置表单
      Object.assign(form, {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      })
      showPasswordDialog.value = true
    }

    // 加载店铺信息
    const loadShopInfo = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success) {
          shopLogo.value = response.data.data.shop_logo || '@/assets/logo.gif'
          shopName.value = response.data.data.shop_name || '商户端'
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
        // 使用默认值
        shopLogo.value = '@/assets/logo.gif'
        shopName.value = '商户端'
      }
    }


    onMounted(() => {
      loadPoints()
      loadShopInfo() // 新增：加载店铺信息
      fetchModuleStatus(); // 新增：加载模块权限


    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      userAvatar,
      username,
      activeMenu,
      sqNum,          // 新增
      formattedOutDate, // 新增
      handleLogout,
      handleNavClick,
      showPasswordDialog,
      form,
      showCardDialog,
      cardForm,
      showCardRechargeDialog,
      submitCardRecharge,
      submitPassword,
      shopLogo,
      shopName,
      moduleStatus,
      userInfo,
      handleModifyPassword
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  display: flex;

  background: linear-gradient(135deg, #f8f9fc 0%, #eef1f6 100%);
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}

.sidebar {
  width: 220px;
  background: linear-gradient(195deg, #1a2847 0%, #2a3f5f 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .logo-container {
    padding: 24px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    text-align: center;

    .logo-img {
      width: 64px;
      height: 64px;
      border: 2px solid rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      transition: all 0.3s;
    }

    .logo-title {
      margin: 12px 0 0;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
      background: linear-gradient(to right, #fff 0%, #a0b9ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: rgba(255, 255, 255, 0.05);
  padding: 12px 8px;
  height: auto;

  :deep(.el-submenu__title),
  :deep(.el-menu-item) {
    height: 48px;
    margin: 4px 0;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 20px !important;
    display: flex !important;
    align-items: center;

    .el-icon {
      font-size: 18px;
      flex-shrink: 0;
      width: 24px;
      margin-right: 11px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.08) !important;
      transform: translateX(4px);
    }


  }

  :deep(.el-sub-menu) {

    // 调整箭头图标位置
    .el-sub-menu__icon-arrow {
      right: 12px !important;
      margin-top: -7px !important;
    }

    // 保持与普通菜单项相同的文字缩进
    .el-sub-menu__title span {
      margin-left: -1px;
    }
  }

  // 统一所有菜单项的图标间距
  :deep(.el-menu-item .el-icon),
  :deep(.el-sub-menu__title .el-icon) {
    margin-right: 11px !important;
  }

  :deep(.el-menu-item)>span,
  :deep(.el-submenu__title)>span {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }

  :deep(.el-menu-item.is-active) {
    background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, transparent 100%) !important;
    border-left: 4px solid #409EFF;

    &::after {
      content: none;
    }
  }

  // 新增二级菜单缩进
  :deep(.el-sub-menu) {
    .el-menu-item {
      padding-left: 50px !important; // 增加30px缩进
      position: relative;


    }

    // 保持激活状态样式
    .el-menu-item.is-active {
      padding-left: 48px !important; // 保持缩进一致性
    }
  }
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 64px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .nav-left {
    display: flex;
    gap: 16px;
    margin-right: 30px;

    .nav-img {
      height: 42px;
      padding: 8px;
      border-radius: 8px;

      transition: all 0.3s;
      cursor: pointer;

      &:hover {
        background: rgba(64, 158, 255, 0.2);
        transform: translateY(-2px);
      }
    }
  }

  .nav-center {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-left: auto; // 保持靠右对齐

    .info-item {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      border-radius: 8px;
      font-size: 14px;
      transition: all 0.3s;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

      .icon {
        font-size: 16px;
        margin-right: 8px;
      }

      .label {
        font-weight: 500;
        margin-right: 4px;
      }

      .value {
        font-weight: 600;
      }

      // 不同项目的背景颜色
      &.points {
        background: #409EFF;
        color: white;

        .icon {
          color: #a0d8ff;
        }
      }

      &.auth {
        background: #67c23a;
        color: white;

        .icon {
          color: #b3e19d;
        }
      }

      &.expire {
        background: #e6a23c;
        color: white;

        .icon {
          color: #f3d19e;
        }
      }

      // 悬停效果
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 12px;
    transition: background 0.3s;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
    }

    .el-avatar {
      box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
    }

    .username {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .arrow-icon {
      margin-left: 6px;
      color: #666;
      font-size: 12px;
      transition: transform 0.3s;
    }
  }
}

.main-content-container {
  flex: 1;
  overflow-y: auto;
  background: transparent;

  .main-content {
    background: #ffffff;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
    padding: 0px;
    min-height: 100vh;
    border: 1px solid rgba(0, 0, 0, 0.05);
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.4);
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}
</style>